import React from 'react';
import { useI18n } from '../i18n/I18nProvider';
import { SEO } from '../components/SEO';

export default function MentionsLegalesPage() {
  const { t } = useI18n();

  const sections = [
    { k: 'editor', label: t('legal.editor'), body: t('legal.editorBody') },
    { k: 'director', label: t('legal.director'), body: t('legal.directorBody') },
    { k: 'hosting', label: t('legal.hosting'), body: t('legal.hostingBody') },
    { k: 'ip', label: t('legal.ip'), body: t('legal.ipBody') },
    { k: 'data', label: t('legal.data'), body: t('legal.dataBody') },
  ];

  return (
    <main className="bg-background">
      <SEO title={t('legal.title')} description="Mentions légales — SARL Blue Star · Tahitian Move." />

      <section className="pt-40 pb-16 md:pt-48 md:pb-24 bg-paper">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <p className="eyebrow">SARL Blue Star</p>
          <h1 className="display text-6xl md:text-8xl mt-6">{t('legal.title')}</h1>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6 md:px-10 space-y-14">
          {sections.map((s) => (
            <div key={s.k} className="border-t border-sand pt-8">
              <p className="eyebrow text-lagoon">{s.label}</p>
              <p className="mt-4 text-ink-soft text-base md:text-lg leading-relaxed whitespace-pre-line">
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
